import { RiSunFill, RiMoonFill } from "react-icons/ri";

function NavDarkModeToggle({ darkMode, setDarkMode }) {
  const toggle = () => {
    setDarkMode(() => {
      if (darkMode === "light") {
        return "dark";
      } else {
        return "light";
      }
    });
  };
  return (
    <>
      <div className="nav__btn">
        <button onClick={toggle} className="light__toggle">
          <RiSunFill
            className={`light__button ${darkMode === "dark" ? "active" : ""}`}
          />
          <RiMoonFill
            className={`dark__button ${darkMode === "light" ? "active" : ""}`}
          />
        </button>
      </div>
    </>
  );
}

export default NavDarkModeToggle;
